<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>    

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <v-tab-item>
          <v-autocomplete
            v-model="employeeReport"
            label="Report Types"
            :items="reportTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <report-employee-basic-information
            v-if="employeeReport === 'Head Count'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
          <report-employee-details-information
            v-if="employeeReport === 'Employee Details'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
          <report-employee-payroll-company
            v-if="employeeReport === 'Employee Payroll Company'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
          <report-employee-family-details
            v-if="employeeReport === 'Family Details'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />        
          <report-employee-movements
            v-if="employeeReport === 'Movements'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
          <report-employee-disciplinary
            v-if="employeeReport === 'Disciplinary'"
            :employees="employees"
            :positions="positions"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>      
</template>

<script>
  export default {
    components: {
      ReportEmployeeBasicInformation: () => import('@/components/hris/reports/employee/BasicInformation'),
      ReportEmployeeDetailsInformation: () => import('@/components/hris/reports/employee/DetailsInformation'),
      ReportEmployeeFamilyDetails: () => import('@/components/hris/reports/employee/FamilyDetails'),
      ReportEmployeeMovements: () => import('@/components/hris/reports/employee/Movements'),
      ReportEmployeeDisciplinary: () => import('@/components/hris/reports/employee/Disciplinary'),
      ReportEmployeePayrollCompany: () => import('@/components/hris/reports/employee/PayrollCompany'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Employee Reports' },
        ],
        active: 0,
        employeeReport: null,
        reportTypes: [
          ...(this.$hasPermissionTo(['generate disciplinary report']) ? [{ name: 'Disciplinary' }] : []),
          ...(this.$hasPermissionTo(['generate employee details report']) ? [{ name: 'Employee Details' }] : []),
          ...(this.$hasPermissionTo(['generate employee payroll company report']) ? [{ name: 'Employee Payroll Company' }] : []),
          ...(this.$hasPermissionTo(['generate family details report']) ? [{ name: 'Family Details' }] : []),
          ...(this.$hasPermissionTo(['generate head count report']) ? [{ name: 'Head Count' }] : []),
          ...(this.$hasPermissionTo(['generate employee movements report']) ? [{ name: 'Movements' }] : []),
        ],
        employees: [],
        positions: [],
        departments: [],
        companies: [],
        loading: false,
        appOrg: process.env.VUE_APP_ORG,
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.employees().list(),
        this.$api.positions().list(),
        this.$api.hrisDepartments().list(['name'], false, true),
        this.$api.hrisCompanies().list('?organization=' + this.appOrg),
      ])
        .then(([employees, positions, departments, companies]) => {
          let temp = employees.data.filter(employee => {
            return employee.department_id !== null
          })

          this.employees = _.orderBy(temp, ['person.name'], ['asc'])
          this.positions = positions.data.map(pos => ({
            id: pos.id,
            label: `${pos.name} (${pos.job_grade.job_group.name})`,
          }))
          this.departments = departments.data
          this.companies = _.orderBy(companies.data, ['name'], ['asc'])

          this.loading = false
        })
    },
  }
</script>
